import type { ReactNode } from "react";

/** ONE mechanism for status vocabularies (U6). Each module declares its
 *  domain map (states are domain knowledge and STAY in the module); this
 *  renders any of them with a consistent look — and because donut slices read
 *  `color` from the same map, chip and chart can never drift apart. */
export type StatusMap = Record<string, { label: string; color: string }>;

export function StatusChip({ st, map, children }: {
  st: string;
  map: StatusMap;
  /** Optional custom text (e.g. "REASSIGN · seq 3"); defaults to the map label. */
  children?: ReactNode;
}) {
  const m = map[st] ?? { label: st.toUpperCase(), color: "var(--t-mute)" };
  return (
    <span className="chip" style={{
      color: m.color,
      background: `color-mix(in srgb, ${m.color} 12%, transparent)`,
      border: `1px solid color-mix(in srgb, ${m.color} 35%, transparent)`,
    }}>{children ?? m.label}</span>
  );
}
